import { atom } from 'jotai';

import { scaleDetailQueryAtom } from '../_graphql/queryScaleDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $scaleSidecarId = settingsRouteParamAtom(
  ['/hardware/scales/:sidecarId/:scaleId'],
  'sidecarId',
);

export const $scaleId = settingsRouteParamAtom(
  ['/hardware/scales/:sidecarId/:scaleId'],
  'scaleId',
);

export const $remoteScaleDetail = scaleDetailQueryAtom((get) => ({
  variables: { id: get($scaleId) ?? '' },
  skip: !get($scaleId),
}));

export const $isScaleLoading = atom((get) => {
  const data = get($remoteScaleDetail);
  return data?.isLoading ?? false;
});

export const $scaleError = atom((get) => {
  const data = get($remoteScaleDetail);
  return data?.error ?? null;
});
